// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import { type NamedRef, type NamedRefWireFormat, NewNamedRef } from '../NamedRef/NamedRef';

export class ImportedDiscountSummary {
  readonly id: string;
  readonly externalID: string;
  readonly name: string;
  readonly amount: string;
  readonly amountType: string;
  readonly stackable: boolean;
  readonly validFrom: DateTime | null;
  readonly validTo: DateTime | null;
  readonly status: Enums.ImportedDiscountStatus;
  readonly companies: NamedRef[];
  readonly plants: NamedRef[];
  readonly productNames: string[];
  readonly productCount: number;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.externalID = data.externalID === undefined ? '' : data.externalID;
    this.name = data.name === undefined ? '' : data.name;
    this.amount = data.amount === undefined ? '0' : data.amount;
    this.amountType = data.amountType === undefined ? '' : data.amountType;
    this.stackable = data.stackable === undefined ? false : data.stackable;
    this.validFrom = DateHelpers.ParseServerNullableDate(data.validFrom);
    this.validTo = DateHelpers.ParseServerNullableDate(data.validTo);
    this.status = data.status === undefined ? Enums.ImportedDiscountStatus.Active : data.status;
    this.companies = (data.companies ?? []).map((companies: any) => NewNamedRef(companies));
    this.plants = (data.plants ?? []).map((plants: any) => NewNamedRef(plants));
    this.productNames = data.productNames ?? [];
    this.productCount = data.productCount === undefined ? 0 : data.productCount;
  }

  static zero(): ImportedDiscountSummary {
    const zeroValues: ExcludeMethodsDeep<ImportedDiscountSummary> = {
      id: NIL_UUID,
      externalID: '',
      name: '',
      amount: '0',
      amountType: '',
      stackable: false,
      validFrom: null,
      validTo: null,
      status: Enums.ImportedDiscountStatus.Active,
      companies: [],
      plants: [],
      productNames: [],
      productCount: 0,
    };
    return new ImportedDiscountSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ImportedDiscountSummaryWireFormat = {
  id: string;
  externalID: string;
  name: string;
  amount: string;
  amountType: string;
  stackable: boolean;
  validFrom: string | null;
  validTo: string | null;
  status: string;
  companies: NamedRefWireFormat[];
  plants: NamedRefWireFormat[];
  productNames: string[];
  productCount: number;
};

type NewImportedDiscountSummaryProps = PartialDeep<
  ImportedDiscountSummary,
  { recurseIntoArrays: true }
>;
export const NewImportedDiscountSummary: (
  props: NewImportedDiscountSummaryProps,
) => ImportedDiscountSummary = (props) => new ImportedDiscountSummary(props);

type NewImportedDiscountSummaryFromWireFormatProps = PartialDeep<
  ImportedDiscountSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewImportedDiscountSummaryFromWireFormat: (
  props: NewImportedDiscountSummaryFromWireFormatProps,
) => ImportedDiscountSummary = (props) => new ImportedDiscountSummary(props);
